<template>
  <div class="container-fluid">
    <b-row class="admin-page">
      <div class="col-md-8">
        <b-form class="admin-form" @submit.stop.prevent="submitTeam">
          <b-form-group horizontal label="Name">
            <b-form-input type="text" v-model="team.name"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="warning" @click="resetTeam(team.id)">Reset</b-button>
          <b-button type="delete" variant="danger" v-if="team.hasOwnProperty('id')" @click="deleteTeam(team.id)">Delete</b-button>
          <b-button v-if="!team.slack_channel && team.hasOwnProperty('id')" type="submit" variant="primary" @click="createSlackChannel(team.id)">Create Slack Channel</b-button>
        </b-form>
      </div>
      <div class="col-md-4">
        <MultiUserSelector v-if="team.hasOwnProperty('id')" :parent="team" :parentPath="'team'"/>
      </div>
    </b-row>
    <br>
    <b-row>
      <div class="col-md-3">
        <span style="float: left;">Adworks Products</span>
      </div>
      <div class="col-md-12">
        <v-select label="name" multiple v-model="team.products" :options="products" />
      </div>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {teamMixins} from '@/mixins/teamMixins'
import MultiUserSelector from '@/components/selectors/users/MultiUserSelector'
export default {
  name: 'Team',
  props: ['teamId'],
  mixins: [teamMixins],
  components: {
    MultiUserSelector
  },
  data () {
    return {
      team: {
        users: [],
        products: [],
        name: ''
      }
    }
  },
  created () {
    this.getOrCreate()
  },
  updated () {

  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    submitTeam () {
      let teamObject = this.team
      teamObject.products = teamObject.products.map(product => product.id)
      if (teamObject.hasOwnProperty('id')) {
        this.$http.put(('/teams/' + teamObject.id), {team: teamObject})
          .then(response => this.submitSuccessful(response))
          .catch((e) => this.error(e))
      } else {
        this.$http.post('/teams', {team: teamObject})
          .then(response => this.createSuccessful(response))
          .catch((e) => this.error(e))
      }
    },
    createSlackChannel (id) {
      this.$http.put(('/teams/' + id), {create_slack_channel: true})
        .then(response => this.submitSuccessful(response))
        .catch((e) => this.error(e))
    },

    getProducts () {
      this.$http.get('/products')
        .then(response => {
          this.products = response.data
          this.team.products = this.team.products.map(product => {
            return {id: product, name: this.products.find(p => p.id === product).name}
          })
        })
        .catch((e) => this.error(e))
    },

    deleteTeam (id) {
      this.$http.delete('/teams/' + id)
        .then(response => this.deleteSuccessful(response))
        .catch((e) => this.error(e))
    },
    submitSuccessful (response) {
      this.$emit('submit-successful')
    },
    deleteSuccessful (response) {
      this.$emit('delete-successful')
    },
    getOrCreate () {
      this.getProducts()
      if (this.teamId) {
        this.getTeam(this.teamId)
      } else {
        this.setBlankTeam()
      }
    }
  },
  watch: {
    teamId: function () {
      this.getOrCreate()
      this.submitText = 'Submit'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/teams/Show.vue